import axios from 'axios';
import {
  ChatRequest,
  ChatResponse,
  InterviewSession,
  InterviewSessionSummary,
  StartInterviewRequest,
  GenerateQuestionsRequest,
  ChatConfig,
  UserSessionStatistics
} from '../types/chat';

class ChatService {
  // Send a chat message
  async sendMessage(request: ChatRequest): Promise<ChatResponse> {
    const response = await axios.post<ChatResponse>('/api/chat/message', request);
    return response.data;
  }

  // Start a new interview session
  async startInterview(request: StartInterviewRequest): Promise<InterviewSession> {
    const response = await axios.post<InterviewSession>('/api/chat/interview/start', request);
    return response.data;
  }

  // Get an interview session
  async getInterviewSession(sessionId: string): Promise<InterviewSession> {
    const response = await axios.get<InterviewSession>(`/api/chat/interview/${sessionId}`);
    return response.data;
  }

  // End an interview session
  async endInterview(sessionId: string): Promise<InterviewSessionSummary> {
    const response = await axios.post<InterviewSessionSummary>(`/api/chat/interview/${sessionId}/end`);
    return response.data;
  }

  // Get user's interview history with pagination
  async getInterviewHistory(page: number = 1, pageSize: number = 10): Promise<InterviewSession[]> {
    const response = await axios.get<InterviewSession[]>(`/api/chat/interview/history?page=${page}&pageSize=${pageSize}`);
    return response.data;
  }

  // Generate practice questions
  async generateQuestions(request: GenerateQuestionsRequest): Promise<string[]> {
    const response = await axios.post<string[]>('/api/chat/questions/generate', request);
    return response.data;
  }

  // Get user's interview statistics
  async getUserStatistics(): Promise<UserSessionStatistics> {
    const response = await axios.get<UserSessionStatistics>('/api/chat/statistics');
    return response.data;
  }

  // Check if user can start a new session
  async canStartSession(): Promise<boolean> {
    const response = await axios.get<boolean>('/api/chat/can-start-session');
    return response.data;
  }

  // Get chat configuration
  async getChatConfig(): Promise<ChatConfig> {
    const response = await axios.get<ChatConfig>('/api/chat/config');
    return response.data;
  }

  /** Anonymous demo — no JWT required. Rate-limited by IP on server. */
  async startGuestInterview(request: StartInterviewRequest): Promise<InterviewSession> {
    const response = await axios.post<InterviewSession>('/api/chat/guest/start', request);
    return response.data;
  }

  async sendGuestMessage(sessionId: string, message: string): Promise<ChatResponse> {
    const response = await axios.post<ChatResponse>('/api/chat/guest/message', {
      sessionId,
      message,
    });
    return response.data;
  }
}

export const chatService = new ChatService();

